import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { contentManagementActions } from 'apps/cms/store'
import { getTikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { FLOW_NAME, NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { FailedToCreateTikTokFollowWelcomeFlowError } from 'shared/errors/clientLayerError'
import { createAsyncAction } from 'shared/lib/redux'

export const createTikTokFlow = createAsyncAction(
  `${NAMESPACE}/createFlow`,
  async (_, { dispatch }) => {
    const flowData = await dispatch(
      contentManagementActions.createAutomation({ name: FLOW_NAME }),
    ).unwrap()

    if (!flowData) {
      throw new FailedToCreateTikTokFollowWelcomeFlowError()
    }

    const replacedFlowData = await tiktokApi.tikTokFollowReply.replaceFlow({
      body: { flow_ns: flowData.flow.ns },
    })

    return replacedFlowData.data
  },
)

export const createTikTokFlowReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder.addCase(createTikTokFlow.fulfilled, (state, action) => ({
    ...state,
    ...getTikTokFollowWelcomeState(action.payload),
  }))
}
